import { useQuery } from "@tanstack/react-query";
import { csmCompaniesRepository } from "@/modules/authentication/repositories/csm-companies-repository";
import { getFlavor } from "@/modules/flavor/actions/get-flavor";

export function useCsmCompaniesQuery() {
    return useQuery({
        queryKey: ["csm-companies"],
        queryFn: async () => {
            const flavor = await getFlavor();
            const companies = await csmCompaniesRepository.fetchAll();

            switch (flavor.name) {
                case "gestione licenze":
                    return companies;
                case "novacolor":
                    return companies.filter((e) => e.domain === "novacolor.it");
                case "csm":
                    return companies.filter(
                        (e) => e.domain === "san-marco.com",
                    );
            }
        },
    });
}
